import { create } from 'zustand';
import { IAutoMessage } from './AutoTablePart';

export interface ISingleAutoMessage {
  singleMessage: IAutoMessage | null;
  setSingleMessage: (row: IAutoMessage | null) => void;
}

export const useSingleAutoMessage = create<ISingleAutoMessage>(set => ({
  singleMessage: null,
  setSingleMessage: singleMessage => set({ singleMessage }),
}));
